export const TRIGGER_NAME = {
  ACTIVITY_COMPLETED: "ActivityCompleted",
  STEP_IN_ACTIVITY_COMPLETED: "StepInActivityCompleted",
  ACTIVITY_MISSED: "ActivityMissed",
  PARTICIPANT: "Participant",
  MILESTONE_COMPLETED: "MilestoneCompleted"
};

export const ACTION_NAME = {
  ADD_AN_ACTIVITY: "addActivity",
  REMOVE_AN_ACTIVITY: "removeActivity",
  NOTIFY_SITE_TEAM_MEMBER: "notifySiteTeam"
};

export const SCHEDULINGS_NAME = {
  IMMEDIATELY: "immediately",
  NO_OF_DAYS: "noOfDays",
  MILESTONE: "milestone",
  CUSTOM: "custom"
};

export const DYNAMIC_SCHEDULES_LIMIT = 55;
export const DYNAMIC_SCHEDULED_ACTIONS_LIMIT = 27;
export const ACTIVITIES_ALLOWED_LIMIT = 1000;
export const NOTIFY_RESEARCH_TEAM_SELECTION_LIMIT = 25;
